export const UserCollectionData = {
  genderList: [
    {
      name: "Uomo",
      value: "Uomo",
      color: "#FFFFFF",
      backgroundColor: "#a81b38"
    },
    {
      name: "Donna",
      value: "Donna",
      color: "#FFFFFF",
      backgroundColor: "#a81b38"
    }
  ],
  ageList: [
    {
      name: "18-30",
      value: "18-30",
      color: "#FFFFFF",
      backgroundColor: "#a81b38"
    },
    {
      name: "31-40",
      value: "31-40",
      backgroundColor: "#a81b38"
    },
    {
      name: "41-65",
      value: "41-65",
      color: "#FFFFFF",
      backgroundColor: "#a81b38"
    },
    {
      name: "66-80",
      value: "66-80",
      color: "#FFFFFF",
      backgroundColor: "#a81b38"
    }
  ],
  yearList: [
    {
      name: "7",
      value: "7",
      color: "#FFFFFF",
      backgroundColor: "#a81b38"
    },
    {
      name: "8",
      value: "8",
      color: "#FFFFFF",
      backgroundColor: "#a81b38"
    },
    {
      name: "9",
      value: "9",
      color: "#FFFFFF",
      backgroundColor: "#a81b38"
    },
    {
      name: "10",
      value: "10",
      color: "#FFFFFF",
      backgroundColor: "#a81b38"
    },
    {
      name: "11",
      value: "11",
      color: "#FFFFFF",
      backgroundColor: "#a81b38"
    },
    {
      name: "12",
      value: "12",
      color: "#FFFFFF",
      backgroundColor: "#a81b38"
    },
    {
      name: "13",
      value: "13",
      color: "#FFFFFF",
      backgroundColor: "#a81b38"
    },
    {
      name: "14",
      value: "14",
      color: "#FFFFFF",
      backgroundColor: "#a81b38"
    },
    {
      name: "15",
      value: "15",
      color: "#FFFFFF",
      backgroundColor: "#a81b38"
    }
  ]
};
